module.exports = __webpack_public_path__ + "static/media/img.voided-check.900fa556.png";